
import { defineComponent } from 'vue';
import { ColorToneGenerator } from '@/color-tone-generator';

export default defineComponent( {
  props: {
    color: { type: String, required: true, },
    tone: { type: String, required: true, },
  },
  methods: {
    darkText(): boolean {
      return !ColorToneGenerator.isDarkColor( this.color );
    },
  },
} );
